import React from 'react';
import { Clickable } from '@moda/om';
import { ResponsiveImage } from '../../ResponsiveImage';
import { OrderItem } from '../../../hooks/useOrder';

import './OrderItemImage.scss';

interface Props {
  item: OrderItem;
  imageSize: 'small' | 'medium';
}

export const OrderItemImage: React.FC<Props> = ({
  item: {
    attributes: {
      details: { name },
      images: { small, medium },
      productHref
    }
  },
  imageSize
}) => (
  <Clickable to={productHref}>
    <ResponsiveImage
      className="OrderItemImage__image"
      src={imageSize === 'small' ? small : medium}
      alt={name}
      maxWidth={160}
      maxHeight={280}
    />
  </Clickable>
);
